function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M52.2404 25.8064C54.5883 25.8064 56.9566 23.9689 56.9566 21.2739C56.9566 15.7614 50.7091 17.5989 50.7091 15.1897C50.7091 14.5772 51.1175 14.1076 51.8729 14.1076C52.6283 14.1076 53.0775 14.4751 53.302 15.1897H56.7729C56.2216 12.2906 54.3433 10.9431 51.8729 10.9431C49.5658 10.9431 47.32 12.5968 47.32 15.2714C47.32 20.7431 53.5675 18.8647 53.5675 21.3556C53.5675 22.0293 53.0979 22.6418 52.2404 22.6418C51.3829 22.6418 50.7704 22.1926 50.5458 21.3556H47.075C47.5854 24.2139 49.5045 25.8064 52.2404 25.8064Z",
  fill: "#0F1322"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M63.8791 25.8064C66.2066 25.8064 68.4933 24.4181 69.1466 21.5189H65.7575C65.3696 22.4785 64.7571 22.9072 63.8791 22.9072C62.5521 22.9072 61.715 21.9272 61.715 20.2122C61.715 18.4972 62.5521 17.5172 63.8791 17.5172C64.6754 17.5172 65.3491 17.8643 65.7575 18.7014H69.1466C68.4321 15.9451 66.1454 14.6181 63.8791 14.6181C61.1637 14.6181 58.4891 16.5372 58.4891 20.2122C58.4891 23.8872 61.1637 25.8064 63.8791 25.8064Z",
  fill: "#0F1322"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M70.8803 25.5206H73.9836V19.5997C73.9836 18.2726 74.8411 17.3131 77.1891 17.8031V14.6181C75.9232 14.6181 74.7595 15.1489 73.9836 16.1697V14.9039H70.8803V25.5206Z",
  fill: "#0F1322"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M82.6132 25.8064C83.879 25.8064 85.0428 25.2756 85.8186 24.2547V25.5206H88.9219V14.9039H85.8186V20.8247C85.8186 22.1518 84.9611 22.9072 83.7157 22.9072C82.6132 22.9072 81.919 22.1518 81.919 20.8247V14.9039H78.8157V21.4372C78.8157 24.2139 80.2857 25.8064 82.6132 25.8064Z",
  fill: "#0F1322"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M104.566 19.5997V25.5206H107.669V18.9872C107.669 16.2106 106.322 14.6181 104.076 14.6181C102.606 14.6181 101.32 15.2306 100.523 16.3943C99.9313 15.251 98.8901 14.6181 97.4813 14.6181C96.338 14.6181 95.2355 15.1489 94.4801 16.1493V14.9039H91.3767V25.5206H94.4801V19.5997C94.4801 18.2726 95.3376 17.5172 96.3788 17.5172C97.3996 17.5172 97.9713 18.2726 97.9713 19.5997V25.5206H101.075V19.5997C101.075 18.2726 101.932 17.5172 102.973 17.5172C103.994 17.5172 104.566 18.2726 104.566 19.5997Z",
  fill: "#0F1322"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M110.119 25.5206H113.385V20.7431H114.569C117.367 20.7431 119.51 18.8239 119.51 15.986C119.51 13.1481 117.367 11.2289 114.569 11.2289H110.119V25.5206ZM113.385 17.6806V14.2914H114.569C115.611 14.2914 116.121 15.1081 116.121 15.986C116.121 16.8639 115.611 17.6806 114.569 17.6806H113.385Z",
  fill: "#0F1322"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M126.034 25.8064C128.912 25.8064 131.73 23.8872 131.73 20.2122C131.73 16.5372 128.912 14.6181 126.034 14.6181C123.155 14.6181 120.337 16.5372 120.337 20.2122C120.337 23.8872 123.155 25.8064 126.034 25.8064ZM123.563 20.2122C123.563 18.4972 124.543 17.5172 126.034 17.5172C127.524 17.5172 128.504 18.4972 128.504 20.2122C128.504 21.9272 127.524 22.9072 126.034 22.9072C124.543 22.9072 123.563 21.9272 123.563 20.2122Z",
  fill: "#0F1322"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M133.765 25.5206H136.869V11.2289H133.765V25.5206ZM136.869 19.8039L139.441 25.5206H142.871L140.135 19.5385L142.565 14.9039H139.421L136.869 19.8039Z",
  fill: "#0F1322"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M149.057 25.8064C151.099 25.8064 153.283 24.7243 154.202 22.4581H150.609C150.302 22.846 149.833 23.0297 149.057 23.0297C147.995 23.0297 146.995 22.4785 146.668 21.1922H154.365V20.2122C154.365 16.5372 151.65 14.6181 148.955 14.6181C146.26 14.6181 143.585 16.5372 143.585 20.2122C143.585 23.8872 146.362 25.8064 149.057 25.8064ZM146.709 19.0281C147.036 17.7214 147.914 17.1089 148.955 17.1089C149.833 17.1089 150.854 17.5785 151.119 19.0281H146.709Z",
  fill: "#0F1322"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M156.415 25.5206H159.518V19.5997C159.518 18.2726 160.376 17.3131 162.724 17.8031V14.6181C161.458 14.6181 160.294 15.1489 159.518 16.1697V14.9039H156.415V25.5206Z",
  fill: "#0F1322"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M164.35 25.5206H167.617V20.7431H168.801C171.598 20.7431 173.742 18.8239 173.742 15.986C173.742 13.1481 171.598 11.2289 168.801 11.2289H164.35V25.5206ZM167.617 17.6806V14.2914H168.801C169.842 14.2914 170.353 15.1081 170.353 15.986C170.353 16.8639 169.842 17.6806 168.801 17.6806H167.617Z",
  fill: "#0F1322"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M175.276 25.5206H178.38V19.5997C178.38 18.2726 179.237 17.3131 181.585 17.8031V14.6181C180.319 14.6181 179.156 15.1489 178.38 16.1697V14.9039H175.276V25.5206Z",
  fill: "#0F1322"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M188.4 25.8064C191.279 25.8064 194.096 23.8872 194.096 20.2122C194.096 16.5372 191.279 14.6181 188.4 14.6181C185.521 14.6181 182.704 16.5372 182.704 20.2122C182.704 23.8872 185.521 25.8064 188.4 25.8064ZM185.93 20.2122C185.93 18.4972 186.91 17.5172 188.4 17.5172C189.891 17.5172 190.87 18.4972 190.87 20.2122C190.87 21.9272 189.891 22.9072 188.4 22.9072C186.91 22.9072 185.93 21.9272 185.93 20.2122Z",
  fill: "#0F1322"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M8.46774 7.45161C8.46774 6.45394 9.27652 5.64516 10.2742 5.64516H15.129C16.1267 5.64516 16.9355 6.45394 16.9355 7.45161V15.129C16.9355 16.1267 16.1267 16.9355 15.129 16.9355H10.2742C9.27652 16.9355 8.46774 16.1267 8.46774 15.129V7.45161Z",
  fill: "url(#paint0_radial)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M27.5484 8.46774C28.5461 8.46774 29.3548 9.27652 29.3548 10.2742V15.129C29.3548 16.1267 28.5461 16.9355 27.5484 16.9355H19.871C18.8733 16.9355 18.0645 16.1267 18.0645 15.129V10.2742C18.0645 9.27652 18.8733 8.46774 19.871 8.46774L27.5484 8.46774Z",
  fill: "url(#paint1_radial)"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M15.129 18.0645C16.1267 18.0645 16.9355 18.8733 16.9355 19.871V24.7258C16.9355 25.7235 16.1267 26.5323 15.129 26.5323H7.45161C6.45394 26.5323 5.64516 25.7235 5.64516 24.7258V19.871C5.64516 18.8733 6.45394 18.0645 7.45161 18.0645H15.129Z",
  fill: "url(#paint2_radial)"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M26.5323 27.5484C26.5323 28.5461 25.7235 29.3548 24.7258 29.3548H19.871C18.8733 29.3548 18.0645 28.5461 18.0645 27.5484L18.0645 19.871C18.0645 18.8733 18.8733 18.0645 19.871 18.0645H24.7258C25.7235 18.0645 26.5323 18.8733 26.5323 19.871L26.5323 27.5484Z",
  fill: "url(#paint3_radial)"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M35 12.7581C35 14.0052 33.989 15.0161 32.7419 15.0161C31.4948 15.0161 30.4839 14.0052 30.4839 12.7581C30.4839 11.511 31.4948 10.5 32.7419 10.5C33.989 10.5 35 11.511 35 12.7581Z",
  fill: "url(#paint4_radial)"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M15.0161 2.25806C15.0161 3.50516 14.0052 4.51613 12.7581 4.51613C11.511 4.51613 10.5 3.50516 10.5 2.25806C10.5 1.01097 11.511 0 12.7581 0C14.0052 0 15.0161 1.01097 15.0161 2.25806Z",
  fill: "url(#paint5_radial)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M24.6129 32.7419C24.6129 33.989 23.6019 35 22.3548 35C21.1077 35 20.0968 33.989 20.0968 32.7419C20.0968 31.4948 21.1077 30.4839 22.3548 30.4839C23.6019 30.4839 24.6129 31.4948 24.6129 32.7419Z",
  fill: "url(#paint6_radial)"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M4.51613 22.3548C4.51613 23.6019 3.50516 24.6129 2.25806 24.6129C1.01097 24.6129 0 23.6019 0 22.3548C0 21.1077 1.01097 20.0968 2.25806 20.0968C3.50516 20.0968 4.51613 21.1077 4.51613 22.3548Z",
  fill: "url(#paint7_radial)"
});

var _ref23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(17.5 17.5) rotate(90) scale(28.1694)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DE4116"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F56139"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(17.5 17.5) rotate(90) scale(28.1694)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DE4116"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F56139"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint2_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(17.5 17.5) rotate(90) scale(28.1694)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DE4116"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F56139"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint3_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(17.5 17.5) rotate(90) scale(28.1694)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DE4116"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F56139"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint4_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(17.5 17.5) rotate(90) scale(28.1694)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DE4116"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F56139"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint5_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(17.5 17.5) rotate(90) scale(28.1694)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DE4116"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F56139"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint6_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(17.5 17.5) rotate(90) scale(28.1694)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DE4116"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F56139"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint7_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(17.5 17.5) rotate(90) scale(28.1694)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DE4116"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F56139"
})));

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 35,
    viewBox: "0 0 195 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7a6c1739.svg";
export { ForwardRef as ReactComponent };